import { TextField, Autocomplete } from '@mui/material'
import { EXPENSE_TYPE_WIDTH } from 'config'

interface OptionIF {
  label: string
  value: string
}

interface Props {
  onChange: (...events: any[]) => void
  options?: OptionIF[]
}

export default function ExpenseTypeInput(props: Props) {
  const { onChange, options, ...other } = props
  return (
    <Autocomplete
      options={options!}
      getOptionLabel={(o: any) => {
        // o has one of 2 types(o.label or o)
        // (be careful: this behavior can varies
        // between the versions of autocomplete component)
        return o.label ? o.label : options!.find((i) => i.value === o)?.label || ''
      }}
      onChange={(_e, option) => onChange(option?.value || '')}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            variant="outlined"
            margin="dense"
            style={{ width: EXPENSE_TYPE_WIDTH }}
          />
        )
      }}
      {...other}
    />
  )
}
